// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XDPo","name":"styles_name__3-itA","phone":"styles_phone__1kHjj"};